import * as Types from '../types-api.generated';

import { BookmarkFragment, MomentOverviewFragment, MomentFragment, UserLightFragment, WorldOverviewFragment } from '../api-fragments.generated';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiCreateBookmarkVariables = Types.Exact<{
  momentId: Types.Scalars['Int'];
}>;


export type ApiCreateBookmark = { createBookmark: { id: string, publicKey: string, createdAt: string, content: { id: number, name: string, description: string | null, worldId: number, posterUrl: string, startsAt: string, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, world: { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } } } };



export const ApiCreateBookmarkDocument = /*#__PURE__*/ `
    mutation CreateBookmark($momentId: Int!) {
  createBookmark(momentId: $momentId) {
    ...BookmarkFragment
  }
}
    ${BookmarkFragment}
${MomentOverviewFragment}
${MomentFragment}
${UserLightFragment}
${WorldOverviewFragment}`;

export const useCreateBookmark = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiCreateBookmark, TError, ApiCreateBookmarkVariables, TContext>) => {
    
    return useMutation<ApiCreateBookmark, TError, ApiCreateBookmarkVariables, TContext>(
      {
    mutationKey: ['CreateBookmark'],
    mutationFn: (variables?: ApiCreateBookmarkVariables) => apiFetcher<ApiCreateBookmark, ApiCreateBookmarkVariables>(ApiCreateBookmarkDocument, variables)(),
    ...options
  }
    )};


useCreateBookmark.fetcher = (variables: ApiCreateBookmarkVariables, options?: RequestInit['headers']) => apiFetcher<ApiCreateBookmark, ApiCreateBookmarkVariables>(ApiCreateBookmarkDocument, variables, options);
